/**
 * @generated SignedSource<<6d58431c95cbf3312e893a1cb0820993>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "LineOfService",
  "kind": "LinkedField",
  "name": "lineOfService",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveFrom",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveTo",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine1",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine2",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v14 = [
  (v4/*: any*/),
  (v2/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "LocationVersion",
  "kind": "LinkedField",
  "name": "applicableVersion",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tin",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "middleInitial",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nickName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameSuffix",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qualification",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateOfBirth",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowedToBePcp",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "credentialingDelegated",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willingToSeePeopleWithLimitedEnglish",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willingToSeeMinorities",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willingToSeePeopleWithDisabilities",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willingToSeePeopleWithDiverseSexualOrientations",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willingToSeePeopleWithDiverseGenderIdentities",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willingToSeePeopleLivingInRuralAreas",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willingToSeePeopleAdverselyAffectedByPovertyOrInequality",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOrder",
  "storageKey": null
},
v34 = [
  (v2/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoCode",
    "storageKey": null
  },
  (v33/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "display",
  "storageKey": null
},
v36 = [
  (v35/*: any*/),
  (v2/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v38 = [
  (v2/*: any*/),
  (v35/*: any*/)
],
v39 = [
  (v2/*: any*/),
  (v4/*: any*/),
  (v33/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PractitionerDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PractitionerInfo_Practitioner"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerVersion",
                "kind": "LinkedField",
                "name": "applicableVersion",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LegalContract",
                "kind": "LinkedField",
                "name": "legalContract",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Location",
                    "kind": "LinkedField",
                    "name": "locations",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "LocationFragments_LocationDropdown"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalContractLineOfService",
                    "kind": "LinkedField",
                    "name": "linesOfService",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ContractLinesOfServiceFragments_LinesOfService"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingGroup",
                    "kind": "LinkedField",
                    "name": "billingGroups",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BillingGroupFragments_BillingGroupDropdown"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerVersion",
                "kind": "LinkedField",
                "name": "versions",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PractitionerVersions_Versions"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerLanguage",
                "kind": "LinkedField",
                "name": "languages",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PractitionerLanguages_Languages"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerIdentifier",
                "kind": "LinkedField",
                "name": "identifiers",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PractitionerIdentifiers_Identifiers"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProviderBillingAddress",
                "kind": "LinkedField",
                "name": "billingAddresses",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProviderBillingAddresses_Addresses"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerContactPoint",
                "kind": "LinkedField",
                "name": "contactPoints",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PractitionerContactPoints_ContactPoints"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerLocation",
                "kind": "LinkedField",
                "name": "locations",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PractitionerLocations_Locations"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TermLocationsModal_LocationDropdown"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Practitioner",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentifierUseCode",
        "kind": "LinkedField",
        "name": "allIdentifierUseCodes",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllIdentifierUseCodes"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentifierType",
        "kind": "LinkedField",
        "name": "allIdentifierTypes",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllIdentifierTypes"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Gender",
        "kind": "LinkedField",
        "name": "allGenders",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllGendersDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfessionalDesignation",
        "kind": "LinkedField",
        "name": "allProfessionalDesignations",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllProfessionalDesignationDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Language",
        "kind": "LinkedField",
        "name": "allLanguages",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllLanguagesDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Ethnicity",
        "kind": "LinkedField",
        "name": "allEthnicities",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllEthnicitiesDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LegalContract",
        "kind": "LinkedField",
        "name": "allLegalContracts",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContractFragments_AllContractsDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ContactPointUseCode",
        "kind": "LinkedField",
        "name": "allContactPointUseCodes",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllContactPointUseCodesDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ContactPointSystemCode",
        "kind": "LinkedField",
        "name": "allContactPointSystemCodes",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllContactPointSystemCodesDropdown"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PractitionerDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LegalContract",
                "kind": "LinkedField",
                "name": "legalContract",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalContractLineOfService",
                    "kind": "LinkedField",
                    "name": "linesOfService",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "otherServicesDiscountPercentage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "percentageOfBase",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isComplex",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Location",
                    "kind": "LinkedField",
                    "name": "locations",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingGroup",
                    "kind": "LinkedField",
                    "name": "billingGroups",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegalContract",
                        "kind": "LinkedField",
                        "name": "legalContract",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerVersion",
                "kind": "LinkedField",
                "name": "applicableVersion",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Gender",
                    "kind": "LinkedField",
                    "name": "gender",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Ethnicity",
                    "kind": "LinkedField",
                    "name": "ethnicity",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfessionalDesignation",
                    "kind": "LinkedField",
                    "name": "professionalDesignation",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProviderBillingAddress",
                "kind": "LinkedField",
                "name": "billingAddresses",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalContractLineOfService",
                    "kind": "LinkedField",
                    "name": "lineOfService",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LineOfService",
                        "kind": "LinkedField",
                        "name": "lineOfService",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "npi",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billingPermitted",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "addressLine3",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "County",
                    "kind": "LinkedField",
                    "name": "county",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phoneNumber",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerLocation",
                "kind": "LinkedField",
                "name": "locations",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Location",
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingGroup",
                        "kind": "LinkedField",
                        "name": "billingGroup",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalContractLineOfService",
                    "kind": "LinkedField",
                    "name": "legalContractLineOfService",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PractitionerLocationVersion",
                    "kind": "LinkedField",
                    "name": "applicableVersion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showInDirectory",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerVersion",
                "kind": "LinkedField",
                "name": "versions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v23/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v30/*: any*/),
                  (v29/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v25/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Gender",
                    "kind": "LinkedField",
                    "name": "gender",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Ethnicity",
                    "kind": "LinkedField",
                    "name": "ethnicity",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfessionalDesignation",
                    "kind": "LinkedField",
                    "name": "professionalDesignation",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerLanguage",
                "kind": "LinkedField",
                "name": "languages",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Language",
                    "kind": "LinkedField",
                    "name": "language",
                    "plural": false,
                    "selections": (v34/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "seq",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerIdentifier",
                "kind": "LinkedField",
                "name": "identifiers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IdentifierType",
                    "kind": "LinkedField",
                    "name": "identifierType",
                    "plural": false,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IdentifierUseCode",
                    "kind": "LinkedField",
                    "name": "identifierUseCode",
                    "plural": false,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  },
                  (v37/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerContactPoint",
                "kind": "LinkedField",
                "name": "contactPoints",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactPointSystemCode",
                    "kind": "LinkedField",
                    "name": "contactPointSystemCode",
                    "plural": false,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactPointUseCode",
                    "kind": "LinkedField",
                    "name": "contactPointUseCode",
                    "plural": false,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  },
                  (v37/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Practitioner",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentifierUseCode",
        "kind": "LinkedField",
        "name": "allIdentifierUseCodes",
        "plural": true,
        "selections": (v38/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentifierType",
        "kind": "LinkedField",
        "name": "allIdentifierTypes",
        "plural": true,
        "selections": (v38/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Gender",
        "kind": "LinkedField",
        "name": "allGenders",
        "plural": true,
        "selections": (v39/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfessionalDesignation",
        "kind": "LinkedField",
        "name": "allProfessionalDesignations",
        "plural": true,
        "selections": (v39/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Language",
        "kind": "LinkedField",
        "name": "allLanguages",
        "plural": true,
        "selections": (v34/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Ethnicity",
        "kind": "LinkedField",
        "name": "allEthnicities",
        "plural": true,
        "selections": (v39/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LegalContract",
        "kind": "LinkedField",
        "name": "allLegalContracts",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ContactPointUseCode",
        "kind": "LinkedField",
        "name": "allContactPointUseCodes",
        "plural": true,
        "selections": (v38/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ContactPointSystemCode",
        "kind": "LinkedField",
        "name": "allContactPointSystemCodes",
        "plural": true,
        "selections": (v38/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e94b5543d196f7833e15859e3a6733ef",
    "id": null,
    "metadata": {},
    "name": "PractitionerDetailsQuery",
    "operationKind": "query",
    "text": "query PractitionerDetailsQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    id\n    ... on Practitioner {\n      ...PractitionerInfo_Practitioner\n      applicableVersion {\n        displayName\n        id\n      }\n      legalContract {\n        id\n        name\n        locations {\n          ...LocationFragments_LocationDropdown\n          id\n        }\n        linesOfService {\n          ...ContractLinesOfServiceFragments_LinesOfService\n          id\n        }\n        billingGroups {\n          ...BillingGroupFragments_BillingGroupDropdown\n          id\n        }\n      }\n      versions {\n        ...PractitionerVersions_Versions\n        id\n      }\n      languages {\n        ...PractitionerLanguages_Languages\n        id\n      }\n      identifiers {\n        ...PractitionerIdentifiers_Identifiers\n        id\n      }\n      billingAddresses {\n        ...ProviderBillingAddresses_Addresses\n        id\n      }\n      contactPoints {\n        ...PractitionerContactPoints_ContactPoints\n        id\n      }\n      locations {\n        ...PractitionerLocations_Locations\n        ...TermLocationsModal_LocationDropdown\n        id\n      }\n    }\n  }\n  allIdentifierUseCodes {\n    ...Fragments_AllIdentifierUseCodes\n    id\n  }\n  allIdentifierTypes {\n    ...Fragments_AllIdentifierTypes\n    id\n  }\n  allGenders {\n    ...Fragments_AllGendersDropdown\n    id\n  }\n  allProfessionalDesignations {\n    ...Fragments_AllProfessionalDesignationDropdown\n    id\n  }\n  allLanguages {\n    ...Fragments_AllLanguagesDropdown\n    id\n  }\n  allEthnicities {\n    ...Fragments_AllEthnicitiesDropdown\n    id\n  }\n  allLegalContracts {\n    ...ContractFragments_AllContractsDropdown\n    id\n  }\n  allContactPointUseCodes {\n    ...Fragments_AllContactPointUseCodesDropdown\n    id\n  }\n  allContactPointSystemCodes {\n    ...Fragments_AllContactPointSystemCodesDropdown\n    id\n  }\n}\n\nfragment BillingGroupFragments_BillingGroupDropdown on BillingGroup {\n  id\n  name\n  tin\n  legalContract {\n    id\n  }\n}\n\nfragment ContractFragments_AllContractsDropdown on LegalContract {\n  id\n  name\n}\n\nfragment ContractLinesOfServiceFragments_LinesOfService on LegalContractLineOfService {\n  id\n  lineOfService {\n    id\n    name\n  }\n  otherServicesDiscountPercentage\n  percentageOfBase\n  isComplex\n  effectiveFrom\n  effectiveTo\n}\n\nfragment Fragments_AllContactPointSystemCodesDropdown on ContactPointSystemCode {\n  id\n  display\n}\n\nfragment Fragments_AllContactPointUseCodesDropdown on ContactPointUseCode {\n  id\n  display\n}\n\nfragment Fragments_AllEthnicitiesDropdown on Ethnicity {\n  id\n  name\n  displayOrder\n}\n\nfragment Fragments_AllGendersDropdown on Gender {\n  id\n  name\n  displayOrder\n}\n\nfragment Fragments_AllIdentifierTypes on IdentifierType {\n  id\n  display\n}\n\nfragment Fragments_AllIdentifierUseCodes on IdentifierUseCode {\n  id\n  display\n}\n\nfragment Fragments_AllLanguagesDropdown on Language {\n  id\n  name\n  isoCode\n  displayOrder\n}\n\nfragment Fragments_AllProfessionalDesignationDropdown on ProfessionalDesignation {\n  id\n  name\n  displayOrder\n}\n\nfragment LocationFragments_LocationDropdown on Location {\n  id\n  addressLine1\n  addressLine2\n  city\n  state\n  postalCode\n  applicableVersion {\n    name\n    id\n  }\n}\n\nfragment PractitionerContactPoints_ContactPoints on PractitionerContactPoint {\n  id\n  contactPointSystemCode {\n    display\n    id\n  }\n  contactPointUseCode {\n    display\n    id\n  }\n  value\n  effectiveFrom\n  effectiveTo\n}\n\nfragment PractitionerIdentifiers_Identifiers on PractitionerIdentifier {\n  id\n  identifierType {\n    display\n    id\n  }\n  identifierUseCode {\n    display\n    id\n  }\n  value\n  effectiveFrom\n  effectiveTo\n}\n\nfragment PractitionerInfo_Practitioner on Practitioner {\n  id\n  legalContract {\n    id\n    name\n    linesOfService {\n      ...ContractLinesOfServiceFragments_LinesOfService\n      id\n    }\n    locations {\n      ...LocationFragments_LocationDropdown\n      id\n    }\n  }\n  applicableVersion {\n    displayName\n    firstName\n    lastName\n    middleInitial\n    nickName\n    nameSuffix\n    qualification\n    dateOfBirth\n    allowedToBePcp\n    credentialingDelegated\n    willingToSeePeopleWithLimitedEnglish\n    willingToSeeMinorities\n    willingToSeePeopleWithDisabilities\n    willingToSeePeopleWithDiverseSexualOrientations\n    willingToSeePeopleWithDiverseGenderIdentities\n    willingToSeePeopleLivingInRuralAreas\n    willingToSeePeopleAdverselyAffectedByPovertyOrInequality\n    gender {\n      id\n      name\n    }\n    ethnicity {\n      id\n      name\n    }\n    professionalDesignation {\n      id\n      name\n    }\n    id\n  }\n  billingAddresses {\n    ...ProviderBillingAddresses_Addresses\n    id\n  }\n  locations {\n    ...PractitionerLocations_Locations\n    id\n  }\n}\n\nfragment PractitionerLanguages_Languages on PractitionerLanguage {\n  id\n  language {\n    id\n    name\n    isoCode\n    displayOrder\n  }\n  seq\n  effectiveFrom\n  effectiveTo\n}\n\nfragment PractitionerLocations_Locations on PractitionerLocation {\n  id\n  status\n  location {\n    addressLine1\n    addressLine2\n    city\n    state\n    postalCode\n    applicableVersion {\n      name\n      id\n    }\n    billingGroup {\n      id\n      name\n      tin\n    }\n    id\n  }\n  legalContractLineOfService {\n    id\n    lineOfService {\n      id\n      name\n    }\n  }\n  applicableVersion {\n    showInDirectory\n    id\n  }\n}\n\nfragment PractitionerVersions_Versions on PractitionerVersion {\n  id\n  firstName\n  lastName\n  middleInitial\n  nickName\n  dateOfBirth\n  nameSuffix\n  qualification\n  allowedToBePcp\n  willingToSeePeopleWithLimitedEnglish\n  willingToSeeMinorities\n  willingToSeePeopleWithDisabilities\n  willingToSeePeopleWithDiverseGenderIdentities\n  willingToSeePeopleWithDiverseSexualOrientations\n  willingToSeePeopleLivingInRuralAreas\n  willingToSeePeopleAdverselyAffectedByPovertyOrInequality\n  credentialingDelegated\n  effectiveFrom\n  effectiveTo\n  gender {\n    name\n    id\n  }\n  ethnicity {\n    name\n    id\n  }\n  professionalDesignation {\n    name\n    id\n  }\n}\n\nfragment ProviderBillingAddresses_Addresses on ProviderBillingAddress {\n  id\n  lineOfService {\n    id\n    lineOfService {\n      name\n      id\n    }\n  }\n  npi\n  tin\n  billingPermitted\n  name\n  addressLine1\n  addressLine2\n  addressLine3\n  city\n  state\n  postalCode\n  county {\n    id\n    name\n    state\n  }\n  phoneNumber\n  effectiveFrom\n  effectiveTo\n}\n\nfragment TermLocationsModal_LocationDropdown on PractitionerLocation {\n  id\n  status\n  location {\n    addressLine1\n    addressLine2\n    city\n    state\n    postalCode\n    applicableVersion {\n      name\n      id\n    }\n    id\n  }\n  legalContractLineOfService {\n    id\n    lineOfService {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "709d90c12ac6e76ae71f31d4881c637e";

export default node;
